import {
	brand,
	functional,
	global,
	universal
} from './colour-tokens'
import colours from './colours-config';

export default colours;
export { colours as Colours, brand, functional, global, universal };
